import { render } from "./RegisterDemo.vue?vue&type=template&id=4f67ad87"
import script from "./RegisterDemo.vue?vue&type=script&lang=js"
export * from "./RegisterDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__